import { SEO } from "@/components/SEO";
import { LegalLayout } from "@/components/LegalLayout";
import { company } from "@/data/company";

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="How Envago Labs collects, uses and protects your personal information."
        path="/privacy"
      />
      <LegalLayout title="Privacy Policy" updated="June 2026">
        <p>
          Envago Labs ("we", "us" or "our") is committed to protecting your privacy. This Privacy
          Policy explains how we collect, use, disclose and safeguard your information when you
          visit our website or use our applications, including Tanzeen+.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>
            <strong>Information you provide.</strong> When you contact us through our website form
            or by email, we collect your name, email address and the contents of your message.
          </li>
          <li>
            <strong>Usage data.</strong> We may collect standard technical information such as
            browser type, device information and pages visited to improve our website and services.
          </li>
          <li>
            <strong>App data.</strong> Where you use our applications, limited data may be processed
            to deliver features. Product-specific details are described within each app.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To respond to your enquiries and provide support.</li>
          <li>To operate, maintain and improve our website and applications.</li>
          <li>To communicate important updates about our products.</li>
          <li>To comply with legal obligations.</li>
        </ul>

        <h2>3. Legal Basis & Data Responsibility</h2>
        <p>
          We process personal data only where we have a lawful basis to do so, including your
          consent, our legitimate interests, or to fulfil a request you have made. We do not sell
          your personal information.
        </p>

        <h2>4. Data Sharing</h2>
        <p>
          We do not share your personal information with third parties except: (a) trusted service
          providers who help us operate our website and services under confidentiality obligations;
          or (b) where required by law.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We retain personal information only for as long as necessary to fulfil the purposes
          described in this policy, or as required by applicable law.
        </p>

        <h2>6. Security</h2>
        <p>
          We implement reasonable technical and organisational measures to protect your information.
          No method of transmission or storage is completely secure, but we work to safeguard your
          data.
        </p>

        <h2>7. Your Rights</h2>
        <p>
          Depending on your location, you may have the right to access, correct, delete or restrict
          the processing of your personal data. To exercise these rights, contact us at{" "}
          <a href={`mailto:${company.emails.company}`}>{company.emails.company}</a>.
        </p>

        <h2>8. Children's Privacy</h2>
        <p>
          Our services are not directed to children under the age required by applicable law without
          parental consent, and we do not knowingly collect such data.
        </p>

        <h2>9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted on this
          page with an updated revision date.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, contact us at{" "}
          <a href={`mailto:${company.emails.company}`}>{company.emails.company}</a>.
        </p>
      </LegalLayout>
    </>
  );
}
